import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppShell, bindShellUser } from '@/app/shell';

/** User-level pages (settings, guide, organization admin) in the application shell, without a current tenant. */
export const Route = createFileRoute('/_authed/_app')({
  beforeLoad: ({ context }) => bindShellUser(context.me.user.id),
  component: GlobalShell,
});

function GlobalShell() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
